module.exports = __webpack_public_path__ + "static/media/eduction_btm_4.0183fd4d.png";